<template>
                <div v-if="currentRouteName == 'support'">
                  <nav  style="height: 50px;" class="position-relative nav px-4 d-flex align-items-center bg-nav justify-content-center">
                    <div class="position-absolute" style="left: 10px;">
                      <font-awesome-icon class="icon text-white" size="lg" :icon="['fas', 'fa-arrow-left']" />

                    </div>
                      <h6 class="text-white mb-0 fw-bold" style="font-size: 1.1rem;">Online Servi...</h6>
                  </nav>
                  <div class="position-fixed" style="top: 0;right: 0;width: 100vw;height: 100vh;">
                    <router-view></router-view>
                  </div>

                </div>
                <div v-else>

                    <div >
                      <router-link :to="{ name: 'support' }" class="position-fixed" style="z-index: 999;right:15px;top:35%">
                      <img width="50" src="@/assets/cs.png" alt="">
                    </router-link>
                     <nav style="height: 50px;"
                  class="position-relative nav px-4 d-flex align-items-center bg-nav justify-content-center">
                  <img style="width: 35px;" src="@/assets/logo.png" alt="">
                  <span style="font-size:1rem;font-weight:600;color:white">ECOS Ether Cloud</span>

                  <div class="position-absolute justify-content-end text-white d-flex align-items-center"
                    style="top: 0;left: 0;width: 100vw;height: 50px;">
                    <small>{{ displayAddress }}</small>
                  </div>
                </nav>
                  </div>
                  <div class="mb-5">
                      <router-view></router-view>
                    </div>
                  <footer-nav class="position-fixed vw-100" style="bottom: 0;"></footer-nav>

                </div>
                <toast-component :message="toastMessage"></toast-component>
</template>

<script>
import FooterNav from './components/FooterNav.vue';
import { useHead } from '@vueuse/head'
// import WalletConnect from "@walletconnect/client";
// import QRCodeModal from "@walletconnect/qrcode-modal";
// import { Buffer } from 'buffer';
import Web3 from 'web3';
import ToastComponent from './components/ToastComponent.vue';
export default {
  name: 'App',
                setup() {
                  useHead({
                    // Can be static or computed
                    meta: [
                      {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
                      },
                    ],

                  })
                },
                data() {
                  return {
                    web3: null,
                    accounts: [],
                    toastMessage: null,
                    balance: null,
                    usdtContractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT contract address on Ethereum
                    usdtContractABI: [[{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_upgradedAddress", "type": "address" }], "name": "deprecate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "_spender", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "approve", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "deprecated", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_evilUser", "type": "address" }], "name": "addBlackList", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_from", "type": "address" }, { "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transferFrom", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "upgradedAddress", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "balances", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maximumFee", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "unpause", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "_maker", "type": "address" }], "name": "getBlackListStatus", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }, { "name": "", "type": "address" }], "name": "allowed", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "paused", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "who", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "pause", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "newBasisPoints", "type": "uint256" }, { "name": "newMaxFee", "type": "uint256" }], "name": "setParams", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "amount", "type": "uint256" }], "name": "issue", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "amount", "type": "uint256" }], "name": "redeem", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "_owner", "type": "address" }, { "name": "_spender", "type": "address" }], "name": "allowance", "outputs": [{ "name": "remaining", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "basisPointsRate", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "isBlackListed", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_clearedUser", "type": "address" }], "name": "removeBlackList", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "MAX_UINT", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "_blackListedUser", "type": "address" }], "name": "destroyBlackFunds", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "name": "_initialSupply", "type": "uint256" }, { "name": "_name", "type": "string" }, { "name": "_symbol", "type": "string" }, { "name": "_decimals", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "amount", "type": "uint256" }], "name": "Issue", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "amount", "type": "uint256" }], "name": "Redeem", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "newAddress", "type": "address" }], "name": "Deprecate", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "feeBasisPoints", "type": "uint256" }, { "indexed": false, "name": "maxFee", "type": "uint256" }], "name": "Params", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_blackListedUser", "type": "address" }, { "indexed": false, "name": "_balance", "type": "uint256" }], "name": "DestroyedBlackFunds", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_user", "type": "address" }], "name": "AddedBlackList", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_user", "type": "address" }], "name": "RemovedBlackList", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Pause", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Unpause", "type": "event" }]], // Replace with the actual ABI of the USDT contract
                  }
                },
                computed: {
                  displayAddress() {
                    if (this.user) {
                      let address = this.user.wallet_address
                      let length = address.length
                      console.log(length)

                      return address[0] + address[1] + address[2] + address[3] + '....' + address[length - 4] + address[length - 3] + address[length - 2] + address[length - 1]
                    }
                    return "";
                  },

                  user() {
                    return this.$store.state.auth.user
                  },
                  currentRouteName() {
                    return this.$router.currentRoute.value.name
                  }
                },
                methods: {
                  changeLanguage(code) {
                    this.$i18n.locale = code
                  },
                  async connect() {
                    if (typeof window.ethereum !== "undefined") {
                      await window.ethereum.enable();
                      const web3 = new Web3(window.ethereum);
                      if (!this.$store.state.auth.status.loggedIn) {
                        const accounts = await web3.eth.getAccounts();
                        const userAddress = accounts[0]; // Assuming the user has connected their wallet and has at least one account
                        this.$store.dispatch('auth/register', {
                          address: userAddress
                        }).then(() => {
                          alert('Wallet connected!');
                        }).catch((response) => {
                          console.log(response)
                          alert('Can not connect wallet!')
                        })
                      }
                    }
                  },
                  // async transferUSDT(usdtContract, toAddress, amount) {
                  //   try {
                  //     // Assuming your Dapp has sufficient USDT balance and allowance

                  //     // Approve the USDT transfer
                  //     console.log(usdtContract)
                  //     const approvalTx = await usdtContract.methods.approve(toAddress, amount).send({ from: this.trustWalletAddress });
                  //     console.log('Approval Transaction:', approvalTx);

                  //     // // Transfer the USDT
                  //     // const transferTx = await usdtContract.methods.transferFrom(trustWalletAddress, toAddress, amount).send({ from: trustWalletAddress });
                  //     // console.log('Transfer Transaction:', transferTx);
                  //   } catch (error) {
                  //     console.error('Error:', error);
                  //   }
                  // }
                },
                async mounted() {
                  this.web3 = new Web3(window.ethereum);
                  await this.connect()
                  // Define the USDT contract address and ABI


                  // Instantiate the USDT contract
                  // const usdtContract = new this.web3.eth.Contract(this.usdtContractABI, this.usdtContractAddress);
                  // this.transferUSDT(usdtContract, this.usdtContractAddress, 100)


                },
                components: {
                  FooterNav, ToastComponent
                },
                watch: {
                  '$store.state.index.toastMessage': {
                    immediate: true,
                    handler() {
                      let message = this.$store.state.index.toastMessage
                      if (message) {
                        this.toastMessage = message
                        setTimeout(() => {
                          this.toastMessage = null
                          this.$store.state.index.toastMessage = null
          }, 5000)
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}


.bg-pri {
  background-color: #19196f !important;
  color: white !important;
}

.bg-nav {
  background-color: #19196f !important;
}

.bg-sec {
  background-color: #2b3139 !important;
}

.text-sec {
  color: #dbe9f7 !important;
}

.bg-card {
  background-color: #1e2328 !important;
  color: white;
}

body {
  min-height: 100vh;
  background-color: #fff !important;
}

.text-pri {
  color: #7a90d3 !important;
}


.line {
  height: 3px;
  background-image: linear-gradient(90deg, #FF98D7, #8F60FF) !important;
}

.line2 {
  height: 3px !important;
  background: #5e72a6 !important;
  /* background-image: linear-gradient(90deg,#FF98D7,#8F60FF)!important; */
}

.dotted-line {
  background-image: linear-gradient(to right, rgb(94, 115, 166) 0%, rgb(94, 115, 166) 50%, transparent 50%);
  background-size: 20px 3px;
  background-repeat: repeat-x;
  height: 2px;
}

@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');

* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", 'Inter', "Helvetica Neue", sans-serif;
  font-family: -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", 'Inter', "Helvetica Neue", sans-serif;
}
</style>


